export default __webpack_public_path__ + "static/B0228-a561b182f1b0fa223740ad35a0a64a7e.png";